import '@aws-amplify/auth/enable-oauth-listener';
//# sourceMappingURL=enableOAuthListener.mjs.map
